export default __webpack_public_path__ + "static/sumeru-43114060943cf8cad23fd0df8b3dd9c7.jpg";